// import { userService } from '@/plugin/axios'
import { userService } from '../service'; // 首页视图

export function Index() {
  return userService.get('ImportExcel/Index');
} // 查询当前表对应的导入模板数据
// eslint-disable-next-line camelcase

export function LoadData(table_name) {
  return userService.get('ImportExcel/LoadData', {
    params: {
      table_name: table_name
    }
  });
} // 获取导入表信息集

export function GetMstTableList() {
  return userService.get('ImportExcel/GetMstTableList');
} // 获取原始表对应的字段信息集
// eslint-disable-next-line camelcase

export function GetIntiTableColumnList(table_name) {
  return userService.get('ImportExcel/GetIntiTableColumnList', {
    params: {
      table_name: table_name
    }
  });
} // 保存模板数据

export function SaveData(data) {
  return userService.post('ImportExcel/SaveData', data);
} // 导出Excel模板
// eslint-disable-next-line camelcase

export function ExportTPL(table_name) {
  return userService.get('ImportExcel/ExportTPL', {
    params: {
      table_name: table_name
    }
  });
} // 导入Excel文件数据到指定表

export function ImportExcelFile(formData) {
  return userService.post('ImportExcel/ImportExcelFile', formData);
}
export function LoadMainData(query) {
  return userService.get('ImportExcel/LoadMainData', {
    params: query
  });
} // 导入Excel模板

export function ImportExcelDemoFile(formData) {
  return userService.post('ImportExcel/ImportExcelDemoFile', formData);
} // 删除Excel模板

export function DelExcel(formData) {
  return userService.post('ImportExcel/DelExcel', formData);
}